import { Component, h, State, EventEmitter, Event } from '@stencil/core';
import { FirebaseService } from '../../utils/firebase';
import { inputOut } from '../../utils/utils';
import { httpsCallable } from 'firebase/functions';

@Component({
  tag: 'tambr-auth-password-reset',
  styleUrl: 'tambr-auth-password-reset.css',
  shadow: false
})
export class TambrAuthPasswordReset {

  email: string = '';

  @State() errorMessage: string | null = null;
  @State() successMessage: string | null = null;
  @State() loading: boolean = false;

  @Event() tambrChangeLoginForm: EventEmitter<string>;

  handleEmailChange(event) { this.email = event.target.value; }

  async handleSubmit(ev: any) {
    ev.preventDefault();
    this.loading = true;
    this.errorMessage = null;
    this.successMessage = null;
    
    try {
      const resetPassword = httpsCallable( FirebaseService.functions, 'user_resetPassword' );
      const resetPasswordResult = await resetPassword({ email: this.email });
      this.successMessage = 'The password reset instructions have been sent to your email address.';
      console.log(resetPasswordResult);
    } catch (error) {
      this.errorMessage = error.message;
    }
    this.loading = false;
  }

  render() {
    return (
      <form id='tambr-password-reset-form' class='tambr-auth-form' onSubmit={ ev => this.handleSubmit(ev) }>

        <div class={'error message' + (this.errorMessage ? ' show' : '') }>{ this.errorMessage }</div>
        <div class={'success message' + (this.successMessage ? ' show' : '') }>{ this.successMessage }</div>

        <div class='tambr-form-item'>
          <input type='email' id='email' name='email'
            value={ this.email } 
            onInput={ (event) => this.handleEmailChange(event) }
            onBlur={ (event) => inputOut(event) } />
          <label htmlFor='email'>Email</label>
        </div>

        <div class='tambr-action-buttons'>
          <button type='submit' disabled={ this.loading }
            class={ 'tambr-button' + (this.loading ? ' loading' : '') }>
              <div class='tambr-button-loading'><div>Loading...</div></div>
              <span>Reset password</span>
          </button>
          <a class='tambr-clear-button' onClick={ () => this.tambrChangeLoginForm.emit('login') }>Log In</a>
        </div>

      </form>
    )
  }

}
